export function parseCurrency(value = '') {
  let currency;
  const defaultCurrency = 'NGN';
  const currencies = {
    NGN: 'NGN',
    USD: 'USD',
    GHS: 'GHS',
  };

  if (currencies[value]) {
    currency = currencies[value];
  } else {
    // If currency is not in our predefined list, return it as-is instead of defaulting to NGN
    currency = value || defaultCurrency;
  }

  return currency;
}

export function generateCurrencyId(value = '') {
  let currencyId;
  const defaultCurrency = 'NGN';
  const currencies = {
    NGN: 566,
    USD: 840,
    GHS: 936, // ISO 4217 currency code for Ghana Cedi
  };

  if (currencies[value]) {
    currencyId = currencies[value];
  } else currencyId = defaultCurrency;

  return currencyId;
}

export function parseBillingInterval(value = 1) {
  let interval;
  const defaultInterval = 'Monthly';

  const intervals = {
    1: 'Weekly',
    2: 'Monthly',
    3: 'Yearly',
  };

  if (intervals[value]) {
    interval = intervals[value];
  } else interval = defaultInterval;

  return interval;
}

export function computeRecurringMeta(interval, cycle) {
  const intervalsObj = {
    1: 7, //weekly
    2: 30, //monthly
    3: 365, //yearly
  };

  const frequency = intervalsObj[interval];
  const duration = frequency * cycle;
  return { frequency, duration };
}
